// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInOut {
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
}

h1.splash-message {
  animation: fadeInOut 2s ease-in-out forwards;
}

.bullet {
  transition: all 0.2s ease-in-out;
}

.bullet.active {
  width: 30px !important;
  background-color: var(--bs-primary) !important;
}

.bullet:hover {
  background-color: var(--bs-primary) !important;
}

.field-description {
  transition: all 0.5s ease-in-out;
}

.field-description.current {
  list-style: none;
  text-align: center;
}

form {
  transition: all 0.5s ease-in-out;
}

form.form-processing-filter {
  transform: scale(0.9);
  filter: blur(2px);
  pointer-events: none;
}

/* Smooth fade-in animation */
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fade-in 0.4s ease-out;
}

/* Smooth spin animation */
@keyframes spin-slow {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin-slow {
  animation: spin-slow 1s linear infinite;
}

/* Hide scrollbar but keep functionality */
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Smooth transitions for history navigation */
.history-transition {
  transition: all 0.3s ease-in-out;
}

/* Improved dropdown animation */
@keyframes dropdown-appear {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-dropdown {
  animation: dropdown-appear 0.2s ease-out;
}

/* Pulse animation for generating state */
@keyframes pulse-subtle {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.animate-pulse-subtle {
  animation: pulse-subtle 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Thumbnail hover effect */
.thumbnail-hover {
  transition: all 0.2s ease-in-out;
}

.thumbnail-hover:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Mobile-optimized spacing */
@media (max-width: 768px) {
  .animate-fade-in {
    animation-duration: 0.3s;
  }
}

/* Loading skeleton for preview */
@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-loading {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
}

/* Smooth gradient animation for generate button */
@keyframes gradient-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.gradient-animate {
  background-size: 200% 200%;
  animation: gradient-shift 3s ease infinite;
}


@keyframes fadeInScale {
  0% {
    opacity: 0;
    transform: scale(0.97) translateY(10px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.animate-fade-in-scale {
  animation: fadeInScale 0.4s ease-out forwards;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/owner-dashboard/account-setup-wizard/steps/hub-home-banner-step/hub-home-banner-step.component.css"],"names":[],"mappings":"AAAA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,8CAA8C;AAC9C;EACE,gCAAgC;AAClC;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,gEAAgE;AAClE;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA,kDAAkD;AAClD;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;;AAGA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,4yMAA4yM","sourcesContent":["@keyframes fadeInOut {\n  0% { opacity: 0; }\n  50% { opacity: 1; }\n  100% { opacity: 0; }\n}\n\nh1.splash-message {\n  animation: fadeInOut 2s ease-in-out forwards;\n}\n\n.bullet {\n  transition: all 0.2s ease-in-out;\n}\n\n.bullet.active {\n  width: 30px !important;\n  background-color: var(--bs-primary) !important;\n}\n\n.bullet:hover {\n  background-color: var(--bs-primary) !important;\n}\n\n.field-description {\n  transition: all 0.5s ease-in-out;\n}\n\n.field-description.current {\n  list-style: none;\n  text-align: center;\n}\n\nform {\n  transition: all 0.5s ease-in-out;\n}\n\nform.form-processing-filter {\n  transform: scale(0.9);\n  filter: blur(2px);\n  pointer-events: none;\n}\n\n/* Smooth fade-in animation */\n@keyframes fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fade-in {\n  animation: fade-in 0.4s ease-out;\n}\n\n/* Smooth spin animation */\n@keyframes spin-slow {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin-slow {\n  animation: spin-slow 1s linear infinite;\n}\n\n/* Hide scrollbar but keep functionality */\n.scrollbar-hide {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n/* Smooth transitions for history navigation */\n.history-transition {\n  transition: all 0.3s ease-in-out;\n}\n\n/* Improved dropdown animation */\n@keyframes dropdown-appear {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-dropdown {\n  animation: dropdown-appear 0.2s ease-out;\n}\n\n/* Pulse animation for generating state */\n@keyframes pulse-subtle {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n.animate-pulse-subtle {\n  animation: pulse-subtle 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* Thumbnail hover effect */\n.thumbnail-hover {\n  transition: all 0.2s ease-in-out;\n}\n\n.thumbnail-hover:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Mobile-optimized spacing */\n@media (max-width: 768px) {\n  .animate-fade-in {\n    animation-duration: 0.3s;\n  }\n}\n\n/* Loading skeleton for preview */\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-loading {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.1) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s ease-in-out infinite;\n}\n\n/* Smooth gradient animation for generate button */\n@keyframes gradient-shift {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.gradient-animate {\n  background-size: 200% 200%;\n  animation: gradient-shift 3s ease infinite;\n}\n\n\n@keyframes fadeInScale {\n  0% {\n    opacity: 0;\n    transform: scale(0.97) translateY(10px);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.animate-fade-in-scale {\n  animation: fadeInScale 0.4s ease-out forwards;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
